var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 126.4 120.2",
        width: "100%",
        height: "100%",
      },
    },
    [
      _c("g", { staticClass: "Layer_2", attrs: { "data-name": "Layer 2" } }, [
        _c(
          "g",
          { staticClass: "Layer_1-2", attrs: { "data-name": "Layer 1" } },
          [
            _c("path", {
              staticClass: "house cls-1",
              attrs: {
                d:
                  "M126.1 20.4L114 13.3V3h-6.3v7L93 1.4l-33.2 19m5.8 0v37.5h53.1V20.3",
              },
            }),
            _c("path", {
              staticClass: "person",
              attrs: {
                fill: "#f7c168",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M98.4 35.2a6.7 6.7 0 11-6.7-6.7 6.6 6.6 0 016.7 6.7zm7 22.7c-2.2-6-6.5-11.3-13.5-11.3-6.2 0-11.5 4.7-13.4 11.3z",
              },
            }),
            _c("circle", {
              staticClass: "front-circle cls-1",
              attrs: { cx: "40.6", cy: "79.7", r: "40.3" },
            }),
            _c("path", {
              staticClass: "hand",
              attrs: {
                fill: "#f6b140",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M18.9 108L28 96.4s1.9-3.3 8.4-2.5c0 0 7.5-4 10.6-1.9 0 0 .5.9 0 1.3s-8.5 3.4-8.5 3.4l12.3-.3 7-6s2.6-3.2 3.8-1.8c1.6 1.9-9.3 12.5-9.3 12.5a5.5 5.5 0 01-5.2 2.4c-3.7-.2-15.2 0-15.2 0l-2.6 4.5z",
              },
            }),
            _c("path", {
              staticClass: "panels",
              attrs: {
                fill: "#00a0df",
                d: "M89.8 3.2l-26.5 15-1.6-3.2L88 0l1.8 3.2z",
              },
            }),
            _c("path", {
              staticClass: "card-back cls-1",
              attrs: {
                d:
                  "M22.4 54h41.8a2.3 2.3 0 012.3 2.4v24.5a2.3 2.3 0 01-2.3 2.3H22.4a2.3 2.3 0 01-2.4-2.3V56.4a2.3 2.3 0 012.4-2.3z",
              },
            }),
            _c("path", {
              staticClass: "card-front",
              attrs: {
                fill: "#eaeaea",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M19.6 56.5h41.8a2.3 2.3 0 012.4 2.3v24.6a2.3 2.3 0 01-2.4 2.2H19.6a2.3 2.3 0 01-2.3-2.2V58.8a2.3 2.3 0 012.3-2.3z",
              },
            }),
            _c("path", {
              staticClass: "bow-cutout",
              attrs: {
                fill: "#fff",
                d:
                  "M38.6 62.4c.8 0 4.3.3 4.6 4.9a3.4 3.4 0 01-1.9 3.1 11.7 11.7 0 01-5.4 1.4h-3.7c1.4-4.6 3.7-9.4 6.4-9.4zm-10 9.4h3.7c-1.4-4.6-3.6-9.4-6.4-9.4-1.3 0-4.3.6-4.6 4.9a3.4 3.4 0 001.8 3.1 11.6 11.6 0 005.5 1.4z",
              },
            }),
            _c("path", {
              staticClass: "front-lines",
              attrs: {
                fill: "none",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M38.2 61.3c.8 0 4.3.3 4.6 5a3.3 3.3 0 01-1.9 3 11.7 11.7 0 01-5.4 1.5h-3.7c1.4-4.6 3.7-9.5 6.4-9.5zm-10 9.5h3.7c-1.4-4.6-3.7-9.4-6.5-9.5-1.3 0-4.3.7-4.5 5a3.3 3.3 0 001.8 3 11.6 11.6 0 005.5 1.5zm9.6 5.9l-6-6L26 77m5.8-20.6v29m32-14.5H17.1",
              },
            }),
            _c("path", {
              staticClass: "dotted-lines",
              attrs: {
                fill: "none",
                stroke: "#7e7e7e",
                "stroke-dasharray": "0 2.78",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d:
                  "M40.5 39.1V25.2a16 16 0 0116-16h9.8m14.4 81.4H99a16 16 0 0015.9-16V60.7",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }